var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendgrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.45 401.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afdef2;}.cls-2{fill:#b0dff2;}.cls-3{fill:#4d81dd;}.cls-4{fill:#65b0df;}.cls-5{fill:#589dd5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 133.82,
    y: 267.43,
    width: 133.82,
    height: 133.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 133.61,
    width: 133.82,
    height: 133.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 267.43,
    width: 133.82,
    height: 133.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 133.82,
    width: 133.82,
    height: 133.82,
    transform: "translate(401.45 133.82) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.82,
    y: 133.82,
    width: 133.82,
    height: 133.82,
    transform: "translate(401.45 401.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 267.63,
    y: 133.82,
    width: 133.82,
    height: 133.82,
    transform: "translate(669.09 401.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 267.63,
    width: 133.82,
    height: 133.82,
    transform: "translate(669.09 133.82) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendgrid);
export default __webpack_public_path__ + "static/media/sendgrid.e360b563e43a55fb7b5aa51e0fb5c0f7.svg";
export { ForwardRef as ReactComponent };